import { render, staticRenderFns } from "./DestinationGroupModal.html?vue&type=template&id=196986ab&external"
import script from "./DestinationGroupModal.ts?vue&type=script&lang=ts&external"
export * from "./DestinationGroupModal.ts?vue&type=script&lang=ts&external"
import style0 from "./DestinationGroupModal.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports